/**
 * ELM Reimbursement AI - Environment Configuration
 * 
 * ============================================================================
 * 🔧 CHANGE ENVIRONMENT HERE - SINGLE PLACE FOR ALL API URLS
 * ============================================================================
 * 
 * TO SWITCH ENVIRONMENTS:
 * 1. Change CURRENT_ENV to 'DEVELOPMENT', 'STAGING', or 'PRODUCTION'
 * 2. Save file
 * 3. Restart development server (npm start)
 * 
 * DEVELOPMENT: Dev Cloud Run backend
 * STAGING: Staging Cloud Run backend (placeholder)
 * PRODUCTION: Production Cloud Run backend
 */

export const ENVIRONMENTS = {
  DEVELOPMENT: {
    API_BASE_URL: 'https://reimbursement-claim-api-678380470209.asia-southeast1.run.app/api',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyBC3Y8nrmIpEAGFeyIIQTW5cM44HjaeP4U",
      authDomain: "in-ai-assistant-sbx-b6fd.firebaseapp.com",
      projectId: "in-ai-assistant-sbx-b6fd",
      storageBucket: "in-ai-assistant-sbx-b6fd.firebasestorage.app",
      messagingSenderId: "229863226360",
      appId: "1:229863226360:web:ebfaeed284390460dd340d"
    },
    NAME: 'Development',
    COLOR: '🟢'
  },
  STAGING: {
    API_BASE_URL: 'https://reimbursement-claim-api-678380470209.asia-southeast1.run.app/api', // TODO: Replace with staging URL
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyBC3Y8nrmIpEAGFeyIIQTW5cM44HjaeP4U",
      authDomain: "in-ai-assistant-sbx-b6fd.firebaseapp.com",
      projectId: "in-ai-assistant-sbx-b6fd",
      storageBucket: "in-ai-assistant-sbx-b6fd.firebasestorage.app",
      messagingSenderId: "229863226360",
      appId: "1:229863226360:web:ebfaeed284390460dd340d"
    },
    NAME: 'Staging',
    COLOR: '🟠'
  },
  PRODUCTION: {
    API_BASE_URL: 'https://reimbursement-claim-api-593913611384.asia-southeast1.run.app/api',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyCLkwi1lyLMF2U3JaeHmqCizHv_paoBTR8",
      authDomain: "in-ai-reimbursemnt-prd-e934.firebaseapp.com",
      projectId: "in-ai-reimbursemnt-prd-e934",
      storageBucket: "in-ai-reimbursemnt-prd-e934.firebasestorage.app",
      messagingSenderId: "593913611384",
      appId: "1:593913611384:web:225e41378a863fec71998d",
      measurementId: "G-NRF6QTX8DK"
    },
    NAME: 'Production',
    COLOR: '🔴'
  }
} as const;

// ============================================================================
// 🔧 CHANGE THIS LINE TO SWITCH ENVIRONMENTS
// ============================================================================
export const CURRENT_ENV = 'PRODUCTION' as 'DEVELOPMENT' | 'STAGING' | 'PRODUCTION';
// ============================================================================

export const ENV_CONFIG = {
  ...ENVIRONMENTS[CURRENT_ENV],
  CURRENT: CURRENT_ENV,
  IS_DEVELOPMENT: CURRENT_ENV === 'DEVELOPMENT',
  IS_STAGING: CURRENT_ENV === 'STAGING',
  IS_PRODUCTION: CURRENT_ENV === 'PRODUCTION'
};

if (process.env.NODE_ENV === 'development') {
  console.log(`${ENV_CONFIG.COLOR} Environment: ${ENV_CONFIG.NAME}`);
  console.log(`🔗 API URL: ${ENV_CONFIG.API_BASE_URL}`);
}

export default ENV_CONFIG;
